// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OpenActivityAfterReallocation from './openActivityReallocation';
import React from 'react';

function OpenActivityAfterReallocationPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-open-activity-after-reallocation-page">
            <OpenActivityAfterReallocation />
        </AuthenticatedPage>
    );

}
OpenActivityAfterReallocationPage.displayNAme = 'OpenActivityAfterReallocationPage';

export default OpenActivityAfterReallocationPage;
